module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic16.0cdbf10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic16.png
// module id = 583
// module chunks = 1